import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Types
import { FieldDefinitions, FieldDefinition } from '@portal/app/shared/types';
import { FieldLabelDTO } from '@libs/api';

export type CTFieldOverrides = Record<string, Record<string, FieldLabelDTO>>;

@Injectable({
  providedIn: 'root'
})
export class FieldService {
  private fieldsSubject = new BehaviorSubject<FieldDefinitions>({});
  fields$ = this.fieldsSubject.asObservable();

  private baseFields: FieldDefinitions = {};
  private ctOverrides: CTFieldOverrides = {};

  getCurrentFields(): FieldDefinitions {
    return this.fieldsSubject.getValue();
  }

  setFields(newFields: FieldDefinitions): void {
    this.baseFields = { ...newFields };
    this.fieldsSubject.next(newFields);
  }

  setCTOverrides(overrides: CTFieldOverrides): void {
    this.ctOverrides = overrides;
  }

  applyFieldLabelOverridesForConversionType(
    conversionType: string | undefined
  ): void {
    if (!conversionType || !Object.keys(this.ctOverrides).length) {
      return;
    }
    const overrides = this.ctOverrides[conversionType];
    const fields = { ...this.baseFields };
    if (overrides) {
      for (const [literalId, override] of Object.entries(overrides)) {
        if (fields[literalId]) {
          fields[literalId] = Object.assign({}, fields[literalId], {
            label: override.label
          });
        }
      }
    }
    this.fieldsSubject.next(fields);
  }

  fieldExists(literalId: string): boolean {
    const fields = this.fieldsSubject.getValue();
    return Object.keys(fields).some(
      (key) => fields[key]?.literalId === literalId
    );
  }

  getFieldDefinitionByLiteralId(literalId: string): FieldDefinition | null {
    const fields = this.fieldsSubject.getValue();
    return fields[literalId] || null;
  }

  getFieldDefinitionByName(name: string): FieldDefinition | null {
    const fields = this.fieldsSubject.getValue();
    const fieldEntry = Object.entries(fields).find(
      (field) => (field[1] || { label: '' }).label === name
    );
    return fieldEntry ? fieldEntry[1] : null;
  }
}
